import React from 'react'
import PropTypes from 'prop-types'
import { AddIcon, ContainedButton } from 'secondstep-components'
import { TextButton } from '../component.styles'

const CREATE_BUTTON_LABEL = 'Create Class'
const CREATE_BUTTON_DATA_TEST_ID = 'button-create'

export const CreateCourseLauncher = ({
  emptyClasses,
  forwardedRef,
  hideLauncher,
  isEditing,
  isLimitReached,
  onCreate,
}) => {
  if (hideLauncher) {
    return null
  }

  if (emptyClasses) {
    return (
      <ContainedButton
        dataTestId={CREATE_BUTTON_DATA_TEST_ID}
        onClick={onCreate}
        ref={forwardedRef}
      >
        {CREATE_BUTTON_LABEL}
      </ContainedButton>
    )
  }

  if (isEditing || isLimitReached) {
    return null
  }

  return (
    <TextButton
      dataTestId={CREATE_BUTTON_DATA_TEST_ID}
      icon={<AddIcon />}
      label={CREATE_BUTTON_LABEL}
      onClick={onCreate}
      ref={forwardedRef}
    />
  )
}

CreateCourseLauncher.propTypes = {
  emptyClasses: PropTypes.bool,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  hideLauncher: PropTypes.bool,
  isEditing: PropTypes.bool,
  isLimitReached: PropTypes.bool,
  onCreate: PropTypes.func.isRequired,
}
